import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code-large, syntax, brackets"} maskId="square-filled-radius-0-stroke-1-IconCodeLarge"><path d="M9.20703 5.5L2.70703 12L9.20703 18.5L8.5 19.207L1.29297 12L8.5 4.79297L9.20703 5.5Z" fill="currentColor"/><path d="M22.707 12L15.5 19.207L14.793 18.5L21.293 12L14.793 5.5L15.5 4.79297L22.707 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCodeLarge;
